export interface ContractorsVendorView {
  contractorName: string;
  reportingManager: string;
  dateOfJoining: string;
  location: string;
  status: string;
  sowExpiryDate: string;
  totalExperience: string;
}

export const columnDefs = [
  { headerName: 'Name', field: 'contractorName' },
  { headerName: 'Reporting Manager', field: 'reportingManager' },
  { headerName: 'Status', field: 'status' },
  { headerName: 'SoW Expiry', field: 'sowExpiryDate' },
  { headerName: 'DOJ', field: 'dateOfJoining' },
  { headerName: 'Location', field: 'location' },
  { headerName: 'Total Exp.', field: 'totalExperience' },
];